import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { planQuery } from '@/api/passes'
import { useCompanyCaller } from '@/app/company'
import { NothingForRole } from '@/app/nothing-for-role'
import { PlanEditor } from '@/app/passes/plan-editor'
import { errorText } from '@/domain/errors'
import { canSeePasses } from '@/domain/pass-abilities'
import { t } from '@/i18n'
import { InlineBanner } from '@/ui/inline-banner'
import { Page } from '@/ui/page'
import { LoadingBlock } from '@/ui/spinner'

export const Route = createFileRoute('/_app/c/$orgId/passes/plans/$planId')({
  component: PlanPage,
})

/// One plan: the constructor for `passes = manage`, read-only for the rest.
function PlanPage() {
  const { orgId, planId } = Route.useParams()
  const { caller } = useCompanyCaller(orgId)
  const allowed = canSeePasses(caller)
  const plan = useQuery({ ...planQuery(orgId, planId), enabled: allowed })

  if (!allowed) return <NothingForRole />
  if (plan.isPending) return <LoadingBlock label={t.app.loading} />
  if (plan.isError) {
    return (
      <Page>
        <InlineBanner
          kind="error"
          message={errorText(plan.error)}
          action={{ label: t.app.retry, onClick: () => void plan.refetch() }}
        />
      </Page>
    )
  }
  return <PlanEditor key={plan.data.id} orgId={orgId} caller={caller} mode={{ kind: 'existing', plan: plan.data }} />
}
